import { BookOpenCheckIcon, CalculatorIcon, ClipboardCheckIcon, DraftingCompassIcon, FireExtinguisherIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Fire Protection Formulas & Calculations Quick-Reference',
    description: 'Key fire protection formulas, unit conversions and reference values gathered in one place.',
    icon: CalculatorIcon,
  },
  {
    number: '2',
    title: 'Fire Protection Inspection & Testing Checklists',
    description: 'Inspection and testing checklists organized by system and frequency.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: 'Fire Extinguisher Selection & Use Field Guide',
    description: 'Extinguisher types, fire classes and how each extinguisher is selected and used.',
    icon: FireExtinguisherIcon,
  },
  {
    number: '4',
    title: 'How to Read Fire Protection Drawings, Riser Diagrams & Cause-and-Effect Matrices',
    description: 'Symbols, riser diagrams and cause-and-effect matrices explained step by step.',
    icon: DraftingCompassIcon,
  },
  {
    number: '5',
    title: 'Fire Protection Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used in fire science, detection, suppression and ITM.',
    icon: BookOpenCheckIcon,
  },
];
